import React from 'react';
import { FieldArray, useFormikContext } from 'formik';
import { Row, Col, Button } from 'react-bootstrap';
import useCurrencies from 'components/Common/Currencies/Hooks/useCurrencies';
import deleteIcon from 'images/icons/invite/delete.svg';
import { TextField, SelectFieldV2 } from '../../../ui/FormElement';

function CurrencyPrice({
  isReadonly,
  collection = null,
  prefixName = '',
  showDeleteButton = true,
  showAddButton = true,
}) {
  const { values } = useFormikContext();
  const { currencies } = useCurrencies();

  return (
    <div>
      <FieldArray name={`${prefixName}currency_prices`}>
        {({ remove, push }) => (
          <div className="mb10">
            {(collection || values.currency_prices).map(
              (price, index) => (
                <Row key={index}>
                  <Col md={showDeleteButton ? 5 : 6}>
                    <SelectFieldV2
                      isDisabled
                      name={`${prefixName}currency_prices.${index}.currency`}
                      placeholder={currencies === null ? 'Wait ...' : 'Currency'}
                      isMulti={false}
                      options={currencies && currencies.map((item) => ({
                        label: item.attributes.title,
                        value: item.attributes.title,
                      }))}
                    />
                  </Col>
                  <Col md={showDeleteButton ? 5 : 6}>
                    <TextField
                      name={`${prefixName}currency_prices.${index}.price`}
                      disabled={isReadonly}
                      type="number"
                      min="0"
                      step="0.01"
                      pattern="d+(.d{1,2})?"
                    />
                  </Col>
                  {showDeleteButton
                  && (
                  <Col md={2}>
                    <a onClick={() => remove(index)}>
                      <img src={deleteIcon} />
                    </a>
                  </Col>
                  )}
                </Row>
              ),
            )}
            {showAddButton && !isReadonly && (
            <div className="text-right">
              <Button
                onClick={() => push({
                  currency: '',
                  price: '',
                })}
                bsStyle="primary"
              >
                Add Price
              </Button>

            </div>
            )}
          </div>
        )}
      </FieldArray>
    </div>
  );
}

export default CurrencyPrice;
